import { render, staticRenderFns } from "./HeaderCollapseWorkTime.vue?vue&type=template&id=b4e07bc0&"
import script from "./HeaderCollapseWorkTime.vue?vue&type=script&lang=js&"
export * from "./HeaderCollapseWorkTime.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCollapseWorkTime.vue?vue&type=style&index=0&id=b4e07bc0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports